// export const basePath = 'http://localhost:3977/api';
export const basePath = 'https://webpersonalmern.herokuapp.com/api';
export const apiVersion = 'v1';
